import { useEffect, useRef, type MouseEvent, type ReactNode } from "react";

export function Modal({ open, onOpenChange, children, label }: {
  open: boolean;
  onOpenChange(open: boolean): void;
  children: ReactNode;
  label: string;
}) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  const backdropClick = (event: MouseEvent<HTMLDialogElement>) => {
    if (event.target === event.currentTarget) onOpenChange(false);
  };

  return (
    <dialog
      ref={ref}
      className="dialog-native"
      role="dialog"
      aria-modal="true"
      aria-label={label}
      // A dialog can host another dialog (the CLABE panel hosts the test top-up). Only events from
      // this element itself may close it; a nested dialog closing must leave its parent open.
      onCancel={(event) => { if (event.target !== event.currentTarget) return; event.preventDefault(); onOpenChange(false); }}
      onClose={(event) => { if (event.target !== event.currentTarget) return; if (open) onOpenChange(false); }}
      onMouseDown={backdropClick}
    >
      {children}
    </dialog>
  );
}
